module.exports = __webpack_public_path__ + "img/telefono.4a998b3f.svg";